import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const UsagePolicyDialog = () =>
  import(/* webpackChunkName: "4-feat-usagepolicydialoglifecycle" */ './UsagePolicyDialogLifecycle');

export default lazyLoadOnRender({ loader: UsagePolicyDialog });
